if (typeof jQuery === "undefined") {
    throw new Error("jQuery plugins need to be before this file");
}

/**
 * permite dar formato a un string
 * @example 'este es un {0}, con valor {1}'.formatter('ejemplo', '5')
 */
String.prototype.formatter = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp("\\{" + i + "\\}", "gm"), arguments[i]);
    }
    return s;
};

var app = {
    //Tomada de underscore.js
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },
    randomKey: function () {
        let array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0];
    },
    alertas: {
        warning: function (contenido, element) {
            let _mensaje =
                "<div class='alert alert-warning alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>" +
                "<h4><i class='icon fa fa-exclamation-triangle'></i> ¡Alerta!</h4>" +
                contenido +
                "</div>";

            $(element).html(_mensaje);
        },
        success: function (contenido, element) {
            let _mensaje =
                "<div class='alert alert-success alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>" +
                "<h4><i class='icon fa fa-check'></i> ¡Mensaje!</h4>" +
                contenido +
                "</div>";

            $(element).html(_mensaje);
        },
        error: function (contenido, element) {
            let _mensaje =
                "<div class='alert alert-danger alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>" +
                "<h4><i class='icon fa fa-ban'></i> ¡Error!</h4>" +
                contenido +
                "</div>";

            $(element).html(_mensaje);
        },
        info: function (contenido, element) {
            let _mensaje =
                "<div class='alert alert-info alert-dismissable'><button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>" +
                "<h4><i class='icon fa fa-info'></i>Información:</h4>" +
                contenido +
                "</div>";

            $(element).html(_mensaje);
        },
        loadder: function (id) {
            if (typeof id === "undefined") {
                id = app.randomKey();
            }
            return (
                '<div id="{0}" class="spinner">'.formatter(id) +
                '<div class="bounce1"></div >' +
                '<div class="bounce2"></div>' +
                '<div class="bounce3"></div>' +
                "</div>"
            );
        },
    },
    validator: {
        /**
         * Remueve las validaciones actuales del formularios y las re-aplica, se usa comúnmente para validar campos traídos por AJAX
         * @param {string} formName nombre formulario
         */
        aplicar: function (formName) {
            if (typeof $.validator === "undefined") {
                return;
            }
            if (typeof formName === "undefined") {
                return;
            }
            let newForm = document.getElementById(formName);
            $("#" + formName).removeData("validator");
            $("#" + formName).removeData("unobtrusiveValidation");
            $.validator.unobtrusive.parse(newForm);
        },
    },
    formato: {
        /**
         * Pasa a formato de moneda colombia
         * @param {string|number} moneda
         * @returns
         */
        cop: function (moneda) {
            return Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(
                moneda
            );
        },
    },
    /**
     *Diferentes mascaras por input mask
     */
    mascara: {
        /**
         *
         * @@param {string?} identificador puede ser vació
         */
        dinero: function (identificador) { },
        /**
         *
         * @@param {string} valor valor con mascara de dinero
         */
        unmaskDinero: function(identificador) { },
        /**
         *
         * @@param {string?} identificador puede ser vació
         */
        porcentaje: function (identificador) { },
        /**
        *
        * @@param {string?} identificador puede ser vació
        */
        dineroNoDecimals: function (identificador) { },
    },
};
